import { Component, OnInit, Input, OnChanges } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-green-button',
  templateUrl: './green-button.component.html',
  styleUrls: ['./green-button.component.scss']
})
export class GreenButtonComponent implements OnInit, OnChanges {
  @Input() disabled!: boolean
  @Input() id: any
  idElement: any
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.id) {
      this.idElement = this.id;
    }
  }
}
